import React, { useState } from "react";
import { FaSave, FaTimes } from "react-icons/fa";

const CategoryForm = ({ category = {}, onSave, onCancel }) => {
  const [name, setName] = useState(category.category_name || "");

  const handleSave = () => {
    if (!name.trim()) {
      alert("Category name is required.");
      return;
    }

    const newCategory = {
      ...category,
      category_name: name.trim(),
      category_id: category.category_id || Date.now().toString(),
    };
    onSave(newCategory);
  };

  return (
    <div className="p-6 border rounded shadow bg-white">
      <h3 className="text-xl font-bold mb-4 flex items-center gap-2 text-blue-600">
        {category.category_id ? "Edit Category" : "Add Category"}
      </h3>
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Category Name:
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter category name"
          className="border p-2 w-full rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
      <div className="flex justify-end gap-4">
        <button
          onClick={onCancel}
          className="bg-gray-500 text-white px-4 py-2 rounded shadow hover:bg-gray-600 flex items-center gap-2"
        >
          <FaTimes /> Cancel
        </button>
        <button
          onClick={handleSave}
          className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 flex items-center gap-2"
        >
          <FaSave /> Save
        </button>
      </div>
    </div>
  );
};

export default CategoryForm;
